/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import createRouter from './router'
import store from './store'
import Axios from 'axios'
import Moment from 'moment'
import jquery from 'jquery'
import echarts from 'echarts'
import '@/icon'
// import  moment
import ElementUI from '@jdpop/element-ui'
import VueI18n from 'vue-i18n'
import filters from './filters'
import cookies from 'js-cookie'
import utils from './utils'
import PopCbUtilEle from '@jdpop/pop-cb-util-ele'
import jdShowMenu from '@jdpop/jd-shop-menu-vue'
import clipboard from 'clipboard'
import mapList from './router/routerMap'
import { zh_CN, en_US } from './languages'
import './assets/css/reset.css'
import '@jdpop/element-ui/lib/theme-chalk/index.css'
import '@jd/belt/lib/theme-default/index.css'
import './assets/css/global.css'
import UnitBelt from '@jd/belt'
import './public-path'

Vue.use(VueI18n)
Vue.use(ElementUI)
Vue.use(PopCbUtilEle)
if (!store.state.inMicroApp) {
  Vue.use(jdShowMenu)
}
Vue.use(UnitBelt)
const router = createRouter()
const Qs = require('qs')
Vue.config.productionTip = false
Axios.defaults.withCredentials = true// Allow Axios cross with cookie
Vue.prototype.axios = Axios
Vue.prototype.jquery = jquery
Vue.prototype.echarts = echarts
Vue.prototype.clipboard = clipboard

Vue.prototype.$moment = Moment
Vue.prototype.$utils = utils()

const i18n = new VueI18n({
  locale: cookies.get('language') || 'zh_CN',
  messages: {
    zh_CN,
    en_US
  },
  silentTranslationWarn: true
})

router.beforeEach((to, from, next) => {
  // console.log('router before each invoked')
  const whiteList = ['/unionActivityList','/unionActivityDetail','/unionActivityApply', '/404']
  const findWhite = (list) => {
   return  list.some((item,index) => {return to.path.indexOf(item) !== -1})
  }
  if (findWhite(whiteList)) {
   next()
  }else {
    next('/404')
  }
})

router.beforeResolve((to, from, next) => {
  // console.log('router before resolve invoked')
  next()
})

router.afterEach((to, from) => {
  // console.log('router after each invoked')
  for (const i in mapList) {
    if (i - 0 === to.meta.menuId) {
      store.commit('changeMenuId', Number(i))
    }
  }
})

// 循环遍历注入过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  beforeCreate () {
    // add request interceptor
    Axios.interceptors.request.use(
      config => {
        // 发送请求之前的操作
        if (config.method === 'get' || config.method === 'delete') {
          config.paramsSerializer = (params) => {
            return Qs.stringify(params, {arrayFormat: 'repeat'})
          }
        }
        return config
      },
      error => {
        // 对请求错误的操作
        console.error(error)
        return Promise.reject(error)
      })
    // add response interceptor
    Axios.interceptors.response.use(
      response => {
        if (response.data.code) {
          if (response.data.code === 1001) { // {{ $t('w248') }}
            this.$alert(this.$t('w686')+'！', this.$t('w687'), {
              confirmButtonText: this.$t('w58'),
              callback: action => {
                let href = window.location.href
                let redirectUrl = response.data.redirectUrl
                let url = redirectUrl.split('?')[0] + '?ReturnUrl=' + href
                window.location.href = window.encodeURI(url)
              }
            })
          } else if (response.data.code === 1003) {
            window.location.href = window.encodeURI(response.data.redirectUrl)
          } else if (response.data.code === 70001) {
            location.href = store.state.inMicroApp ? '//shop.jd.com/jdm/mkt/union/#/401' : '/#/401'
          }
        }
        return response
      },
      error => {
        if (error.data.message) {
          this.$message({
            type: 'error',
            message: error.data.message
          })
        }
        return Promise.error(error)
      })
  },
  render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js